import { IBudgetItem } from '../../createAndEdit/types';
import { parseDiscountPercent } from '../../createAndEdit/utils/budgetCalculations';
import DetailServiceItemRow from './DetailServiceItemRow';

interface IDetailServiceItemsTableProps {
  items: IBudgetItem[];
  serviceSubtotal?: number;
}

const DetailServiceItemsTable = (props: IDetailServiceItemsTableProps) => {
  const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  const parseQuantityToNumber = (qty: string | number | undefined): number => {
    if (qty === undefined || qty === null) return 0;
    const qtyStr = String(qty);
    const clean = qtyStr.replace(/[^\d.,]/g, '').replace(',', '.');
    return Number.parseFloat(clean) || 0;
  };

  const visibleItems = (props.items || []).filter((item) => {
    if (item.removed === true) return false;
    const quantity = parseQuantityToNumber(item.quantity);
    return quantity > 0;
  });

  const calculatedSubtotal = () => {
    return visibleItems.reduce((sum, item) => {
      return sum + (parseQuantityToNumber(item.quantity) * item.value * (1 - parseDiscountPercent(item.discount) / 100));
    }, 0);
  };

  return (
    <table
      className="table table-layout-fixed table-column-overflow-hidden table-head-filled mb-3 w-full [&_td]:border-0 [&_th]:border-0 [&_tbody_tr]:border-0 [&_tbody_tr]:border-b-0 [&_thead_tr]:border-0 [&_thead_tr]:border-b-0 [&_tbody_tr_td]:border-0 [&_tbody_tr_td]:border-b-0 [&_thead_tr_th]:border-0 [&_thead_tr_th]:border-b-0"
      style={{ borderCollapse: 'separate', borderSpacing: 0 }}
    >
      <thead>
        <tr className="border-0 !border-b-0" style={{ borderBottom: 'none' }}>
          <th className="w-[7%] border-0 !border-b-0" style={{ borderBottom: 'none' }}>
            Ref.
          </th>
          <th className="w-[13%] border-0 !border-b-0" style={{ borderBottom: 'none' }}>
            Item
          </th>
          <th className="w-[26%] border-0 !border-b-0" style={{ borderBottom: 'none' }}>
            Descrição
          </th>
          <th className="w-[10%] border-0 !border-b-0" style={{ borderBottom: 'none' }}>
            Quantidade
          </th>
          <th className="w-[12%] border-0 !border-b-0" style={{ borderBottom: 'none' }}>
            Valor (R$)
          </th>
          <th className="w-[10%] border-0 !border-b-0" style={{ borderBottom: 'none' }}>
            % Desconto
          </th>
          <th className="w-[15%] border-0 !border-b-0" style={{ borderBottom: 'none' }}>
            Subtotal (R$)
          </th>
        </tr>
      </thead>
      <tbody>
        {visibleItems.map((item, index) => (
          <DetailServiceItemRow key={`item-${item.ref}-${index}`} item={item} />
        ))}
      </tbody>
      {typeof props.serviceSubtotal === 'number' && (
        <tfoot>
          <tr className="border-0 !border-b-0" style={{ borderBottom: 'none' }}>
            <td className="border-0 !border-b-0" style={{ borderBottom: 'none' }} colSpan={6}></td>
            <td className="border-0 !border-b-0 text-right pr-4" style={{ borderBottom: 'none' }}>
              <span className="text-gray-600 mr-2">Subtotal do serviço:</span>
              <span className="font-bold">{formatCurrency(calculatedSubtotal())}</span>
            </td>
          </tr>
        </tfoot>
      )}
    </table>
  );
};

export default DetailServiceItemsTable;
